import { render, staticRenderFns } from "./GChatDrawerMenuBuyer.vue?vue&type=template&id=6b3f23fd&scoped=true&"
import script from "./GChatDrawerMenuBuyer.vue?vue&type=script&lang=ts&"
export * from "./GChatDrawerMenuBuyer.vue?vue&type=script&lang=ts&"
import style0 from "./GChatDrawerMenuBuyer.vue?vue&type=style&index=0&id=6b3f23fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3f23fd",
  null
  
)

export default component.exports